// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  padding: 5px;
  display: block;
}
ion-radio-group ion-item {
  border-radius: var(--radius-default);
  border: var(--outline-default);
}
ion-radio-group ion-item:not(:last-child) {
  margin-bottom: 5px;
}
ion-radio-group ion-item.selected {
  border: 1px solid var(--color-black);
}

ion-radio {
  --color: var(--ion-color-secondary);
}
ion-radio.radio-checked::part(mark) {
  transform: scale3d(1.1, 1.1, 1);
}

.price {
  font-family: AppFont;
  font-size: 14px;
  line-height: 17.78px;
  text-align: right;
  margin-inline-start: 4px;
  text-align: end;
  color: var(--color-grey);
}

ion-label {
  display: block;
  font-family: AppFont !important;
  font-size: 16px !important;
  line-height: 17.78px;
  text-align: left;
  color: var(--color-black) !important;
}

.measurement {
  font-size: 12px;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

.selected {
  font-family: AppFont, sans-serif;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-single/article-option-group-single.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,cAAA;AACD;AACC;EACC,oCAAA;EACA,8BAAA;AACF;AACE;EACC,kBAAA;AACH;AAEE;EACC,oCAAA;AAAH;;AASA;EACC,mCAAA;AAND;AAQC;EACC,+BAAA;AANF;;AAUA;EACC,oBAAA;EACA,eAAA;EACA,oBAAA;EAEA,iBAAA;EAEA,wBAAA;EACA,eAAA;EACA,wBAAA;AATD;;AAYA;EACC,cAAA;EACA,+BAAA;EACA,0BAAA;EACA,oBAAA;EAEA,gBAAA;EACA,oCAAA;AAVD;;AAYA;EACC,eAAA;AATD;;AAWA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AARD;;AAWA;EACC,qBAAA;AARD;;AAWA;EACC,gCAAA;AARD;;AAWA;EACC,eAAA;AARD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tpadding: 5px;\n\tdisplay: block;\n\n\tion-item {\n\t\tborder-radius: var(--radius-default);\n\t\tborder: var(--outline-default);\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\n\t\t&.selected {\n\t\t\tborder: 1px solid var(--color-black);\n\t\t}\n\n\t\t// &:first-child {\n\t\t// \tborder-top: var(--outline-default);\n\t\t// }\n\t}\n}\n\nion-radio {\n\t--color: var(--ion-color-secondary);\n\n\t&.radio-checked::part(mark) {\n\t\ttransform: scale3d(1.1, 1.1, 1);\n\t}\n}\n\n.price {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 17.78px;\n\t// letter-spacing: 0.01em;\n\ttext-align: right;\n\n\tmargin-inline-start: 4px;\n\ttext-align: end;\n\tcolor: var(--color-grey);\n}\n\nion-label {\n\tdisplay: block;\n\tfont-family: AppFont !important;\n\tfont-size: 16px !important;\n\tline-height: 17.78px;\n\t// letter-spacing: 0.01em;\n\ttext-align: left;\n\tcolor: var(--color-black) !important;\n}\n.measurement {\n\tfont-size: 12px;\n}\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\n\n.selected {\n\tfont-family: AppFont, sans-serif;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
